import React from 'react'
export const styles = {
  icon: {
    fontSize: "24px",
    margin: "8px",
    cursor: "pointer"
  },
  qr: {
    height: "120px"
  },
  logo: {
    height: "28px",
    marginRight: "4px"
  },
  container: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center"
  },
  borderDivider: {
  },
  iconplaystore: {
    cursor: "pointer",
    // background: "black",
    // borderRadius: "3px",
    content: "url(https://rbiretaildirect.org.in/common/img/png/google-store.png)"
  },
  iconappstore: {
    cursor: "pointer",
    // background: "black",
    // borderRadius: "3px",
    content: "url(https://rbiretaildirect.org.in/common/img/png/apple-store.png)"
  }

}
export const PlaystoreDownload = () =>
  <span data-toggle="modal" id="playstoreDownload" data-target="#playstoreDownloadModal" style={styles.iconplaystore} className='mx-1 '>Download App</span>

export const AppstoreDownload = () =>
  <span data-toggle="modal" id="appstoreDownload" data-target="#appstoreDownloadModal" style={styles
    .iconappstore} className='  mx-1'>Download App</span>

const AppLink = () => {
  return (<div id="AppDownloadText" className='mt-4'><AppstoreDownload /> <PlaystoreDownload /></div>)
}
export default AppLink